import { render, staticRenderFns } from "./invoice-view.vue?vue&type=template&id=12624dda&scoped=true&"
import script from "./invoice-view.vue?vue&type=script&lang=js&"
export * from "./invoice-view.vue?vue&type=script&lang=js&"
import style0 from "./invoice-view.vue?vue&type=style&index=0&id=12624dda&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12624dda",
  null
  
)

export default component.exports